import React from 'react'
import CameraIcon from '../../elements/icons/CameraIcon'
import { transactionTimeStamp } from '../../../utils'
import { Link } from 'react-router-dom'
import ArrowIcon from '../../elements/icons/ArrowIcon'
import StudentStatus from '../../elements/StudentStatus'

const StudentCard = ({student}) => {
  return (
    <div className='w-full relative'>
        <div className='bg-gray-50 h-[250px] rounded-[8px] flex items-center justify-center' style={{
        backgroundImage: `url(" ${student.passportPhotograph} ")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'none'
        }}>
            {(!student.passportPhotograph || student.passportPhotograph === '') &&
                <CameraIcon className={`w-8 h-8 text-gray-400`} />
            }
        </div>
        <div className='px-4 py-2'>
            <h3 className='font-space-grotesk font-semibold'>{`${student.firstName}${student.otherNames ? ` ${student.otherNames} ` : ' '}${student.lastName}`}</h3>
            <div className='flex items-center justify-between'>
                <p className='capitalize text-sm mt-2 mb-2'>{student?.gender?.toLowerCase()}</p>
                <StudentStatus status={student?.status} />
            </div>
            <p className='capitalize text-sm mt-2 mb-2'>Date admitted: {transactionTimeStamp(student?.createdAt).date}</p>

            <Link to={`student/${student?._id}`}>
                <button className='text-sm flex flex-row items-center gap-x-3 mt-5 text-vcm-purple hover:text-gray-400 transition duration-200'>See student details <ArrowIcon className={`w-5 h-5`} /></button> 
            </Link>
        </div>
    </div>
  )
}

export default StudentCard

